import React from 'react';
import {
    Group,
    List,
    Text,
    CloseOutlined,
    IconButton,
    ExternalLinkOutlined,
} from '@landr/maestro';
import { t } from '@lingui/macro';

const SuggestionGeneric = ({
    filterCategories,
    filterName,
    handleClick,
    handleRemoveRecentSuggestion,
    icon,
    isModal,
    isSelected = false,
    isRemoveSuggestionVisible = false,
    isNavigationItem = false,
    isDisabled = false,
    hoverRef,
}: {
    filterCategories?: string;
    filterName: string;
    handleClick?: () => void;
    handleRemoveRecentSuggestion?: (event: React.MouseEvent) => void;
    icon: React.ReactElement;
    isModal: boolean;
    isSelected?: boolean;
    isRemoveSuggestionVisible?: boolean;
    isNavigationItem?: boolean;
    hoverRef?: React.MutableRefObject<any>;
    isDisabled?: boolean;
}) => {
    const showAction = isRemoveSuggestionVisible || isNavigationItem;

    return (
        <List.Item
            ref={hoverRef}
            onClick={handleClick}
            minHeight={isModal ? 'md' : 'sm'}
            py="none"
            isSelected={isSelected}
            aria-selected={isSelected}
            disabled={isDisabled}
            width="100%"
            _hover={{
                backgroundColor: 'surface.neutral.medium.hover',
            }}
        >
            <List.ItemIcon mx={{ base: '2xs', md: 'none' }} width="18px">
                <Text color="text.medium" lineHeight="unset">
                    {icon}
                </Text>
            </List.ItemIcon>
            <Group alignItems="center" gap="xs">
                <Group.Item>
                    <Text nbOfLines={1}>{filterName}</Text>
                </Group.Item>
                {!!filterCategories && (
                    <Group.Item>
                        <Text
                            color="text.medium"
                            textStyle="caption"
                            fontWeight="regular"
                        >
                            {filterCategories}
                        </Text>
                    </Group.Item>
                )}
            </Group>
            {showAction && (
                <List.ItemSecondaryAction>
                    {isRemoveSuggestionVisible ? (
                        <IconButton
                            icon={CloseOutlined}
                            variant="subtle"
                            kind="link"
                            size="xs"
                            label={t`Remove`}
                            onClick={handleRemoveRecentSuggestion}
                        />
                    ) : (
                        <ExternalLinkOutlined color="icon.medium" size="md" />
                    )}
                </List.ItemSecondaryAction>
            )}
        </List.Item>
    );
};

export default SuggestionGeneric;
